export default __webpack_public_path__ + "static/media/23.0d85dac2.JPG";